module.exports = __webpack_public_path__ + "img/banner3_m.76f773a4.gif";